import Cart from "./cart";

class Product {
    constructor(section) {
        this.section = section;
        this.mobileButton = this.section.querySelector('#product-form-mobile');
        this.form = this.section.querySelector('form[action^="/cart/add"]');
        this.mainForm = document.querySelector('#product-form');
    }

    init() {
        if(this.form) {
            this.form.addEventListener('submit', (event) => {
                this.submitButton = event.target.querySelector('button[type="submit"]');

                event.preventDefault(); // Prevent the form from submitting normally
                this.initForm(this.form);
              });
        }

        if(this.mobileButton) {
            this.mobileButton.addEventListener('click', (event) => {
                this.submitButton = this.mobileButton;
                this.initForm(this.mainForm);
            });
        }
    }

    initForm(form) {
        // Get the necessary values from the form
        var variantInputs = form.querySelectorAll('input[name^="id"]');
        if (variantInputs.length === 1) {
            var variantId = variantInputs[0].value;
            var quantity = form.querySelector('input[name="quantity"]').value;
            this.sendAddToCartRequest({
                id: variantId,
                quantity: quantity
            });
            return
        } 

        var variantIds = [];
        for (var i = 0; i < variantInputs.length; i++) {
            variantIds.push({
                id: variantInputs[i].value,
                quantity: 1
            });
        }

        this.sendAddToCartRequest({items: variantIds});
    }

    sendAddToCartRequest(data, submitButton) {
        var xhr = new XMLHttpRequest();
        xhr.open('POST', '/cart/add.json', true);
        xhr.setRequestHeader('Content-Type', 'application/json');
        xhr.onload = () => {
            console.log(JSON.parse(xhr.responseText));

            if(xhr.status === 422) {
                const message = JSON.parse(xhr.responseText).message;
                alert(message)
            } else if (xhr.status === 200) {
                const cart = new Cart(document);
                cart.updateCartUi();
                this.updateSubmitButton();
                // Scroll the window down to the element with id 'cart-success'
                if(document.getElementById('cart-success')) {
                    window.scrollTo({
                        top: document.getElementById('cart-success').offsetTop,
                        behavior: 'smooth'
                    });
                }
            }
        };
        xhr.send(JSON.stringify(data));
    }

    updateSubmitButton() {
        const submitButton = this.submitButton;
        const newText = submitButton.getAttribute('data-added-text');
        if(newText) {
            submitButton.innerHTML = newText;
            submitButton.classList.remove('bg-ecomm');
            submitButton.classList.remove('text-ecomm-text');
            submitButton.classList.remove('effect-shine');
            submitButton.classList.add('bg-accent-1');
            submitButton.classList.add('text-black');

            setTimeout(() => {
                submitButton.innerHTML = submitButton.getAttribute('data-original-text');
                submitButton.classList.add('bg-ecomm');
                submitButton.classList.add('text-ecomm-text');
                submitButton.classList.add('effect-shine');
                submitButton.classList.remove('bg-accent-1');
                submitButton.classList.remove('text-black');
            }, 2000);
        }
    }

}

export default Product;
